import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[SwilShare] Uncaught render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert">
          <div className="error-boundary__inner">
            <i className="bi bi-exclamation-triangle-fill error-boundary__icon" aria-hidden="true"></i>
            <h2 className="error-boundary__title">Something went wrong</h2>
            <p className="error-boundary__desc">
              An unexpected error occurred. Please refresh the page or contact support.
            </p>
            <button
              className="doc-action-btn doc-action-btn--primary"
              onClick={() => window.location.reload()}
            >
              <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
